import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type UpdateInveriteRows = {
  label: vp.UpdateInveriteLabel;
  id: vp.UpdateInveriteId;
  preset: keyof vp.TextFieldPresets | undefined;
  required: boolean;
};

const useBuildUpdateInveriteRows = (): UpdateInveriteRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Inverite.Update.Form' });

  return [
    {
      label: t('inveriteApiKey'),
      id: vp.UpdateInveriteId.InveriteAPIKey,
      preset: 'text',
      required: true,
    },
    {
      label: t('inveriteUrl'),
      id: vp.UpdateInveriteId.InveriteUrl,
      preset: 'text',
      required: true,
    },
  ];
};
export default useBuildUpdateInveriteRows;
